/**
* created by hezq on 2019-11-20
*
* description: 存储工具类
*
*/
	
import { Base64 } from 'js-base64';

let stores ={};

/**
 * description: 校验浏览器是否支持localStorage
 *
 * created by hezq on 2019-11-20
 *
*/
function checkLSInBrowser(){
	if(!window.localStorage){
		throw new Error("您的浏览器版本过低，不支持localStorage");
	}else{
		return true;
	}
}

/**
 * description: localStorage 存储
 * @param {String} key 缓存key
 * @param {Object} value 缓存值
 *
 * created by hezq on 2019-11-20
 *
*/
stores.setLS = function(key,value){
	if(checkLSInBrowser()){
		if(typeof value === 'object'){
			value = JSON.stringify(value);
		}
		window.localStorage.setItem(Base64.encode(key),Base64.encode(value));
	}
};

/**
 * description: 获取单个 localStorage 数据
 * @param {String} key 缓存key
 * @param {Boolean} isObject 是否是Object类型
 *
 * created by hezq on 2019-11-20
 *
*/
stores.getLS = function(key,isObject){
	if(checkLSInBrowser()){
		let code = window.localStorage.getItem(Base64.encode(key));

		if(code){
			code = Base64.decode(code);
			if(isObject){
				try{
					code = JSON.parse(code);
				}catch(e){
					throw new Error("parse json error");
				}
			}
			return code;
		}
	}
	return null;
};

/**
 * description: 清空 localStorage 所有数据
 *
 * created by hezq on 2019-11-20
 *
*/
stores.clearLS = function(){
	if(checkLSInBrowser()){
		window.localStorage.clear();
	}
};

/**
 * description: 删除单个 localStorage 数据
 *
 * created by hezq on 2019-11-20
 *
*/
stores.delLS= function(key){
	if(checkLSInBrowser()){
		window.localStorage.removeItem(Base64.encode(key));
	}
};

/**
 * description: 校验浏览器是否支持 sessionStorage
 *
 * created by hezq on 2019-11-20
 *
*/
function checkSSInBrowser(){
	if(!window.sessionStorage){
		throw new Error("您的浏览器版本过低，不支持sessionStorage");
	}else{
		return true;
	}
}

/**
 * description: sessionStorage 存储
 * @param {String} key 缓存key
 * @param {Object} value 缓存值
 *
 * created by hezq on 2019-11-20
 *
*/
stores.setSS = function(key,value){
	if(checkSSInBrowser()){
		if(typeof value === 'object'){
			value = JSON.stringify(value);
		}
		window.sessionStorage.setItem(Base64.encode(key),Base64.encode(value));
	}
};

/**
 * description: 获取单个 sessionStorage 数据
 * @param {String} key 缓存key
 * @param {Boolean} isObject 是否是Object类型
 *
 * created by hezq on 2019-11-20
 *
*/
stores.getSS = function(key,isObject){
	if(checkSSInBrowser()){
		let code = window.sessionStorage.getItem(Base64.encode(key));

		if(code){
			code = Base64.decode(code);
			if(isObject){
				try{
					code = JSON.parse(code);
				}catch(e){
					throw new Error("parse json error");
				}
			}
			return code;
		}
	}
	return null;
};

/**
 * description: 清空 sessionStorage 所有数据
 *
 * created by hezq on 2019-11-20
 *
*/
stores.clearSS = function(){
	if(checkSSInBrowser()){
		window.sessionStorage.clear();
	}
};

/**
 * description: 删除单个 sessionStorage 数据
 *
 * created by hezq on 2019-11-20
 *
*/
stores.delSS= function(key){
	if(checkSSInBrowser()){
		window.sessionStorage.removeItem(Base64.encode(key));
	}
};

export default stores;


// WEBPACK FOOTER //
// ./src/tools/store/index.js